import { BaseModel } from 'sjs-base-model';

export default class CurrentUserModel extends BaseModel {
  userId = '';
  subId = '';
  name = '';
  surname = '';
  status = '';
  email = '';
  provider = '';
  company = '';
  contractStart = '';
  contractEnd = '';
  startState = '';
  licence = '';
  createDate = '';

  constructor(data) {
    super();
    this.update(data);
  }
}